import {Component, Input, OnInit} from '@angular/core';
import {
    DefaultGridButtons,
    GridColumn,
    MxCustomizer,
    MxGridButtonsConfig,
    MxGridCustomizerEvent,
    MxGridService,
} from 'mx-core';
import {PrlTranslateService} from '../../../../../shared/services/prl-translate.service';
import {MxSelection} from '../../../../../../../../mx-core/src/lib/modules/mx-grid/services/selection-type.model';
import {PrlFinanceService} from '../../../services/prl-finance.service';

@Component({
    selector: 'prl-payment-requests',
    standalone: false,
    templateUrl: './prl-payment-requests.component.html',
    styleUrl: './prl-payment-requests.component.scss',
})
export class PrlPaymentRequestsComponent implements OnInit, MxCustomizer<MxGridCustomizerEvent> {
    @Input() balancePerMerchant: boolean = false;

    protected gridService: MxGridService;
    protected addDialog = false;

    private buttonsConfig: MxGridButtonsConfig;
    private gridColumns: GridColumn[] = [];

    constructor(protected readonly financeService: PrlFinanceService,
                private readonly translateService: PrlTranslateService) {
    }

    ngOnInit(): void {
        this.gridColumns = [
            new GridColumn({
                field: 'merchantName',
                label: () => this.translateService.getTranslatedLabel('label.finance.transactions.merchant'),
                sortable: true,
                hidden: false
            }),
            new GridColumn({
                field: 'openingBalanceRounded',
                label: () => this.translateService.getTranslatedLabel('label.finance.account.balance.current.balance.total'),
                sortable: true,
                hidden: false
            }),
            new GridColumn({
                field: 'liabilities',
                label: () => this.translateService.getTranslatedLabel('label.finance.account.balance.liabilities'),
                sortable: true,
                hidden: false
            }),
            new GridColumn({
                field: 'endingBalanceRounded',
                label: () => this.translateService.getTranslatedLabel('label.finance.account.balance.ending.balance'),
                sortable: true,
                hidden: false
            })
        ];

        this.buttonsConfig = new MxGridButtonsConfig([
                [DefaultGridButtons.add, {
                    label: () => this.translateService.getTranslatedLabel('label.finance.payment.request.heading'),
                    icon: 'add',
                    color: 'primary',
                    tooltip: () => this.translateService.getTranslatedLabel('label.finance.payment.request.heading'),
                    className: 'mxs-button--primary',
                    disabled: MxSelection.noneOrMultipleSelection,
                    clickHandler: this.switchComponent
                }],
                [DefaultGridButtons.edit, {
                    hidden: true
                }],
                [DefaultGridButtons.remove, {
                    hidden: true
                }],
                [DefaultGridButtons.view, {
                    hidden: true
                }],
                [DefaultGridButtons.reload, {
                    hidden: true
                }]
            ]);

    }

    onCustomize(event: MxGridCustomizerEvent): void {
        if(!event.customizeRestUrl) {
            return;
        }
        event
            .customizeRestUrl('/finance/balances')
            .customizeLoadRowsOnStart(true)
            .customizeColumns(this.gridColumns)
            .customizeActions(this.buttonsConfig)
            .customizeProps({
                selectionMode: 'single',
                readonly: true,
                showButtons: true,
                showColumns: false
            })
            .onSetUp(service => {
                this.gridService = service;
            });
    }

    public switchComponent = () => {
        this.financeService.setNewPaymentRequest(true);
        this.financeService.setSelectedMerchant(this.gridService.collection.selection.selected[0]);
    };

}
